"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.delegate = void 0;
/**
 * Takes a method as a parameter and add it to the class calling it.
 */
function delegate(method) {
    return function (target, propertyKey) {
        target.constructor.prototype[propertyKey] = method;
    };
}
exports.delegate = delegate;
